<template>
  <section class="hero">
    <div class="hero-body">
      <div class="container has-text-centered">
        <div class="column is-4 is-offset-4">
          <div class="box" style="margin-top: 10vh">
            <p>Please contact Healthy Waters.</p>
          </div>
          <div class="mt-1">
            <p>
              <button class="button is-dark" @click="onLoginIntent">LOGIN</button>
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ErrorMakeContact',
  methods: {
    onLoginIntent() {
      this.$router.push({ name: 'login' });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/Errors/contact/index.vue